import styled from 'styled-components';
import { positions } from 'utils/styles';

export const ProgressBar = styled.div.attrs({
    className: 'cxi-dashboard-progress',
})`
    height: 22rem;
    margin: 0 auto;
    position: relative;
    width: 22rem;
`;

export const ProgressBarContent = styled.div`
    align-items: center;
    color: ${({ theme }) => theme.colors.darkBlue};
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    position: absolute;
    ${positions(0, 0, 0, 0)}
    width: 100%;

    .num {
        font-size: 4.4rem;
        font-weight: 700;
        line-height: 1;
    }
    .txt {
        font-size: 1.4rem;
        font-weight: 600;
        line-height: 1;
        margin-top: 0.8rem;
        opacity: 0.75;
    }
`;

export const ProgressBarCircle = styled.div`
    height: 100%;
    position: absolute;
    ${positions(0, 0, 0, 0)}
    width: 100%;
`;
export const ProgressBarCircleGraph = styled.div`
    height: 100%;
    position: absolute;
    ${positions(0, 0, 0, 0)}
    width: 100%;
`;
